import { dateOrWeekdayFormat, formatTime } from './date-formatter';
import { formatDuration } from './duration-formatter';
import { utcToCentralEuropean } from '../../../play-core/utils/date-helper';
export const getMediaAria = (media, t) => `${media.title}.
  ${t('global.video')}
  ${media.show && media.show.title}
  ${dateOrWeekdayFormat(utcToCentralEuropean(media.date), t)}
  ${formatTime(media.date, t)},
  ${formatDuration(media.duration, t)}`;